import React, { Component } from 'react';
import { Label, UncontrolledTooltip } from "reactstrap";
import { checkEmailAvailabilityNotIn, request } from "../../util/APIUtils";
import { deepCopyObject, showAxiosError, trimObject } from "../../util/Helpers";
import Alert from "react-s-alert";
import emailMask from "text-mask-addons/dist/emailMask";
import MaskedInput from "react-text-mask";
import { validateComponent, validateField } from "../../common/validation";
import { API_BASE_URL } from "../../constants";
import './User.css';
import { Switch } from "antd";
import Select from "../../local_node_modules/react-select";


class UserForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            error: {},
            emailAvailabilityError: {},
            mode: 'create',
            loading: false,
            member: null,
            selectedRoles: [],
            roles: this.props.roles || [],  
            selectedUser: {
                recordId: null,
                username: null,
                name: null,
                surname: null,
                email: null,
                password: null,
                memberId: null,
                odaId: null,
                groupId: null,
                userRoles: null,
               activated: false,
                roleId: null
            },
        };

        this.validateClass = this.validateClass.bind(this);
        this.validateComponent = this.validateComponent.bind(this);
        this.validateField = this.validateField.bind(this);
        this.validateEmailField = this.validateEmailField.bind(this);
        this.validateMessage = this.validateMessage.bind(this);
        this.saveUser = this.saveUser.bind(this);
        this.cancelProcess = this.cancelProcess.bind(this);
        this.onSelectChange = this.onSelectChange.bind(this);
        this.toggle = this.toggle.bind(this);
        this.onChangeRoles = this.onChangeRoles.bind(this);
        this.rolestoSelectElements = this.rolestoSelectElements.bind(this);
        this.validateEmailClass = this.validateEmailClass.bind(this);
        this.handleLogout = this.handleLogout.bind(this);
        this.listRoles = this.listRoles.bind(this);
    }

    componentDidMount() {
        if (this.props.selectedUser) {
            const currRoles = this.rolestoSelectElements();
            this.setState({
                selectedUser: this.props.selectedUser,
                selectedRoles: currRoles
            });
        }
        this.listRoles();
    }   
   

    // listRoles() {
    //     let self = this;
    //     let url = API_BASE_URL + "/roles/select";

    //     let params = {
    //         url,
    //         method: "get",
    //     };
    //     self.setState({ loading: true });
    //     request(params)
    //         .then(function (response) {
    //             self.setState({
    //                 roles: response.data.content,
    //                 loading: false,
    //             });
    //         })
    //         .catch(function (error) {
    //             self.setState({ loading: false, error: "Roller yüklenirken bir sorun oluştu." });
    //             console.error("Hata:", error);
    //         });
    // }
 
    
    listRoles() {
        let self = this;
        let url = API_BASE_URL + "/roles/select";
    
        let params = {
            url,
            method: "get",
        };
        self.setState({ loading: true });
        request(params)
            .then(function (response) {
                let roles = response.data.map(role => ({ value: role.value, label: role.label }));
                self.setState({
                    roles,
                    loading: false,
                });
            })
            .catch(function (error) {
                self.setState({ loading: false, error: "Roller yüklenirken bir sorun oluştu." });
                console.error("Hata:", error);
            });
    }
    


   
    
    rolestoSelectElements() {
        const currRoles = [];
        const attachedRoles = deepCopyObject(this.props.selectedUser.userRoles);
        const allRoles = this.state.roles; 
        if (allRoles && attachedRoles) {
            for (const attachedRole of attachedRoles) {
                for (const role of allRoles) {
                    if (attachedRole.roleId === role.value) {
                        currRoles.push(role);
                    }
                }
            }
        }
        return currRoles;
    }
   
    
    onSelectChange(name, value) {
        let selectedUser = this.state.selectedUser;
        if (value === null) {
            selectedUser[name] = null;
        }
        else {
            selectedUser[name] = value.value;
        }
        this.setState({ selectedUser });
    }
    


    validateField(e) {
        let id = e.target.id;
        let rule = e.target.dataset.vdata;
        let boundary = e.target.dataset.vlength;
        let value = e.target.value;
        console.log("e", e);
        console.log("rule, boundary, value:", rule, boundary, value);
        let result = validateField(rule, boundary, value);
        console.log("result:", result);
        let error = this.state.error;
        error = Object.assign(error, { [id]: result });
        console.log("error:", error);
        this.setState({ error });
    }

    async validateEmailField(e) {
        let id = e.target.id;
        let rule = e.target.dataset.vdata;
        let boundary = e.target.dataset.vlength;
        let recordId = this.state.selectedUser.recordId;
        let value = e.target.value;
        let result = validateField(rule, boundary, value);
        console.log("result:", result);
        let error = this.state.error;
        let emailAvailabilityError = this.state.emailAvailabilityError;
        error = Object.assign(error, { [id]: result });
        console.log("error", error);
    }

    validateClass(id) {
        let error = this.state.error;
        return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
    }

    validateEmailClass(id) {
        let error = this.state.emailAvailabilityError;
        return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
    }

    validateMessage(id) {
        let error = this.state.error;
        return (error[id] === undefined ? '' : (error[id].message));
    }

    validateComponent() {
        let result = validateComponent(this);
        this.setState({
            error: result.error
        });
        return result;
    }

    handleSurnameChange(e) {
        this.setState({
            selectedUser: {
                ...this.state.selectedUser,
                [e.target.name]: e.target.value.toString().toLocaleUpperCase()
            }
        })
    }

    handleNameChange(e) {
        const { value } = e.target;
    
        const capitalizeFirstLetter = (string) => {
            return string.charAt(0).toLocaleUpperCase() + string.slice(1);
        };
    
        const updatedValue = capitalizeFirstLetter(value);
    
        this.setState({
            selectedUser: {
                ...this.state.selectedUser,
                name: updatedValue
            }
        });
    }
    

    onChangeEmail(e) {
        let value;
        if (e.target.name === 'username') {
            value = e.target.value.toString().replace('@', '');
        } else {
            value = e.target.value;
        }
        this.setState({
            selectedUser: {
                ...this.state.selectedUser,
                [e.target.name]: value.toString().toLocaleLowerCase()
            }
        })
    }

    onChangePassword(e) {
        let value;
        value = e.target.value
        this.setState({
            selectedUser: {
                ...this.state.selectedUser,
                [e.target.name]: value.toString().toLocaleLowerCase()
            }
        })
    }

    onChangeCheck(checked) {
        let selectedUser = this.state.selectedUser;
        selectedUser['activated'] = checked;
        this.setState({ selectedUser });
        console.log(selectedUser);
    }

    onChangeRoles(selectedRoles) {
        this.setState({ selectedRoles });
    }
   
   
    saveUser() {
        let self = this;
        let params;
        let data;
        let message;
        let emailAvailable = this.state.emailAvailabilityError['tEmail'] === undefined ? true : (this.state.emailAvailabilityError['tEmail'].valid ? true : false);
        let validity = this.validateComponent();
        if (!this.state.selectedUser.password || this.state.selectedUser.password.length < 6) {
            Alert.error(
                "En az 6 basamaklı bir şifre giriniz!", {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 20000
            });
            return;
        }
        console.log("validity:", validity);
        console.log("emailAvailable:", emailAvailable);
        if (validity.valid && emailAvailable) {
            self.setState({ isLoading: true });
            let userInfo = deepCopyObject(this.state.selectedUser);
            // selectedRoles içinde sadece value alanını gönder
            userInfo.selectedRoles = this.state.selectedRoles.map(role => ({ value: role.value}));
            userInfo = trimObject(userInfo);
            data = userInfo;
            if (userInfo.recordId === null) {
                message = 'Kullanıcı Başarıyla Oluşturuldu.';
            } else {
                message = 'Kullanıcı Başarıyla Güncellendi.';
            }
            params = {
                url: API_BASE_URL + "/user/save-profile",
                data: data,
                method: 'post'
            };
    
            request(params).then(() => {
                Alert.success(
                    message, {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000
                });
                self.setState({ isLoading: false });
                this.cancelProcess();
                self.props.handleSearch(self.props.searchQuery);
            }).catch(function (error) {
                self.setState({ isLoading: false });
                showAxiosError(error);
            });
        } else {
            Alert.error('Hatalı veya eksik alanlar var!', {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 5000
            });
        }
    }

  
    
    cancelProcess() {
        this.props.cancelProcess();
    }

    toggle(tab) {
        this.setState({
            activeTab: tab
        })
    }

    handleLogout() {
        this.props.handleLogout();
    }

    render() {
        const roles = Array.isArray(this.props.roles) ? this.props.roles : [];

        return (
            <div className='user-form-container'>
                <div>
                    <div className="card-body mt-1">
                        <div className="FormRenk col-sm-12">
                            <div className='col-sm-12 row'>
                                <div className="col-sm-3">
                                    <label>Adı *</label>
                                </div>
                                <div className="col-sm-9">
                                    <div className={"form-group" + this.validateClass('tName')}>
                                        <input className="form-control"
                                            type="text"
                                            name="name"
                                            id="tName"
                                            data-vlength="1,50"
                                            onBlur={this.validateField}
                                            ref="tName"
                                            value={this.state.selectedUser.name}
                                            onChange={(e) => this.handleNameChange(e)}
                                        />
                                        {this.validateMessage('tName') !== "" &&
                                            <UncontrolledTooltip placement="right" target="tName" delay={0}>
                                                {this.validateMessage("tName")}
                                            </UncontrolledTooltip>}
                                    </div>
                                </div>
                            </div>

                            <div className='col-sm-12 row'>
                                <div className="col-sm-3">
                                    <label>Soyadı: *</label>
                                </div>
                                <div className="col-sm-9">
                                    <div className={"form-group" + this.validateClass('tSurname')}>
                                        <input className="form-control"
                                            type="text"
                                            name="surname"
                                            id="tSurname"
                                            data-vlength="1,50"
                                            onBlur={this.validateField}
                                            ref="tSurname"
                                            value={this.state.selectedUser.surname}
                                            onChange={(e) => this.handleSurnameChange(e)}
                                        />
                                        {this.validateMessage('tSurname') !== "" &&
                                            <UncontrolledTooltip placement="right" target="tSurname" delay={0}>
                                                {this.validateMessage("tSurname")}
                                            </UncontrolledTooltip>}
                                    </div>
                                </div>
                            </div>

                            <div className='col-sm-12 row'>
                                <div className="col-sm-3">
                                    <label>Kullanıcı Adı: *</label>
                                </div>
                                <div className="col-sm-9">
                                    <div className={"form-group" + this.validateClass('tUsername')}>
                                        <input className="form-control"
                                            type="text"
                                            name="username"
                                            id="tUsername"
                                            data-vlength="1,50"
                                            onBlur={this.validateField}
                                            ref="tUsername"
                                            value={this.state.selectedUser.username}
                                            onChange={(e) => this.onChangeEmail(e)}
                                        />
                                        {this.validateMessage('tUsername') !== "" &&
                                            <UncontrolledTooltip placement="right" target="tUsername" delay={0}>
                                                {this.validateMessage("tUsername")}
                                            </UncontrolledTooltip>}
                                    </div>
                                </div>
                            </div>
                            {!this.props.selectedUser ?
                                <div className='col-sm-12 row'>
                                    <div className="col-sm-3">
                                        <label>Şifre: *</label>
                                    </div>
                                    <div className="col-sm-9">
                                        <div className={"form-group" + this.validateClass('tPassword')}>
                                            <input className="form-control"
                                                type="text"
                                                name="password"
                                                id="tPassword"
                                                data-vlength="1,50"
                                                onBlur={this.validateField}
                                                ref="tUsername"
                                                value={this.state.selectedUser.password}
                                                onChange={(e) => this.onChangePassword(e)}
                                            />
                                            {this.validateMessage('tPassword') !== "" &&
                                                <UncontrolledTooltip placement="right" target="tPassword" delay={0}>
                                                    {this.validateMessage("tPassword")}
                                                </UncontrolledTooltip>}
                                        </div>
                                    </div>
                                </div>
                                : ""
                            }


                            <div className='col-sm-12 row'>
                                <div className="col-sm-3">
                                    <label>E-posta *</label>
                                </div>
                                <div className="col-sm-9">
                                    <div className={"form-group" + this.validateEmailClass('tEmail') + this.validateClass('tEmail')}>
                                        <MaskedInput className="form-control"
                                            type="text"
                                            mask={emailMask}
                                            name="email"
                                            inputProps={{ vdata: "email", vlength: '1,255' }}
                                            id="tEmail"
                                            onBlur={() => this.validateEmailField({
                                                target: {
                                                    id: "tEmail",
                                                    dataset: { vdata: "email", vlength: '1,255' },
                                                    value: this.state.selectedUser.email
                                                }
                                            })}
                                            placeholder="_________@______.___"
                                            ref="tEmail"
                                            value={this.state.selectedUser.email}
                                            onChange={(e) => this.onChangeEmail(e)}
                                        />
                                        {this.validateMessage('tEmail') !== "" &&
                                            <UncontrolledTooltip placement="right" target="tEmail" delay={0}>
                                                {this.validateMessage("tEmail")}
                                            </UncontrolledTooltip>}
                                    </div>
                                </div>
                            </div>

                            <div className="col-sm-12 row">
                                <div className="col-sm-3">
                                    <label>Rol: *</label>
                                </div>
                                <div className="col-sm-9">
                                    <div className={"form-group" + this.validateClass('tRole')}>
                                  <Select
                className="basic-single"
                classNamePrefix="select"
                placeholder="Rol seçiniz."
                isClearable={false}
                isSearchable={true}
                name="roleId"
                id="tRole"
                ref="tRole"
                inputProps={{ 'vdata': "required" }}
                options={this.state.roles}
                onChange={(value) => this.onChangeRoles(value ? [{ value: value.value, label: value.label }] : [])}
                value={this.state.selectedRoles[0] || null}
            />

                                        {this.validateMessage('tRole') !== "" &&
                                            <UncontrolledTooltip placement="right" target="tRole" delay={0}>
                                                {this.validateMessage("tRole")}
                                            </UncontrolledTooltip>}
                                    </div>
                                </div>
                            </div>

                            <div className='col-sm-12 row'>
                                <div className="col-sm-3">
                                    <label>Durum: *</label>
                                </div>
                                <div className="col-sm-9">
                                    <div className="form-group">
                                        <Switch checked={this.state.selectedUser.activated}
                                            name="activated"
                                            checkedChildren="Aktif"
                                            unCheckedChildren="Pasif"
                                            onChange={(e) => this.onChangeCheck(e)} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <div className='col-sm-12 row' id="deleteModal">
                            <div className='col-sm-2'>
                                <button type="button" data-toggle="tooltip" data-placement="bottom"
                                    style={{ background: '#9e9e9e', padding: '10px 54px 10px 23px', width: "150px" }}
                                    rel="tooltip" className="TekBtn vazgec "
                                    onClick={this.cancelProcess}>
                                    İptal
                                </button>
                            </div>
                            <div className="col-sm-8"></div>
                            <div className='col-sm-2'>
                                <button type="button" data-toggle="tooltip" data-placement="bottom"
                                    style={{
                                        background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
                                        float: 'right', padding: '10px 54px 10px 23px', width: "150px"
                                    }}
                                    rel="tooltip" className="TekBtn kaydet"
                                    onClick={() => this.saveUser()}>{this.state.mode === 'create' ? 'Onayla' : 'Kaydet'}
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        )
    }
}

export default UserForm;



// WEBPACK FOOTER //
// ./src/page/user/UserForm.js